module.exports = __webpack_public_path__ + "static/media/44.5cd2156d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/44.svg
// module id = 153
// module chunks = 0